import React, { PropsWithChildren, memo } from 'react';
import Span from '../Span';
import classNames from 'classnames';

type TagProps = {
  className?: string;
  textColor?: string;
  background?: string;
  dataTestId?: string;
  style?: any;
};

const Tag = ({
  children,
  className,
  textColor = 'text-cti-on-primary',
  background = 'bg-amc-gold',
  dataTestId,
  style,
  ...restProps
}: PropsWithChildren<TagProps>) => {
  return (
    <Span
      className={classNames(
        'text-body-xs md:text-body-xs-desktop px-2 py-1 rounded-cxxs',
        textColor,
        background,
        className,
      )}
      dataTestId={dataTestId}
      style={style}
      {...restProps}
    >
      {children}
    </Span>
  );
};

export default memo(Tag);
